import moment from 'moment';

export class MerchantLegalEntityListRequest {
    constructor(params) {
        this.pageNumber = params.pageIndex ?? null;
        this.pageSize = params.pageSize ?? null;
        this.entityType = 'MLE';
        this.sort = 'createdOn';

        this.merchantId = params.merchantId ?? null;
        this.name = params.name ?? null;
        this.source = params.source ?? null;

        if (params.createdOn?.startDate && params.createdOn?.endDate) {
            this.startDate = moment(params.createdOn.startDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            this.endDate = moment(params.createdOn.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }

        // Default to true if enterprise_merchant is undefined
        this.enterpriseMerchant =
            params.enterprise_merchant !== undefined
                ? params.enterprise_merchant === 'yes'
                : true;
    }
}
